<template>
    <ServicePageLayout
        title="Доработка существующих проектов"
        description="Помогаю улучшить уже работающие сайты: исправляю ошибки, добавляю новые разделы, обновляю формы, стили, адаптив и функциональность."
        :includes="includes"
        :audience="audience"
        :steps="steps"
        price="Стоимость доработки — от 1 000 ₽/час. Сроки рассчитываются индивидуально."
    />
</template>

<script setup>
import ServicePageLayout from '@/components/cards/ServicePageLayout.vue';

const includes = [
    'исправление ошибок в интерфейсе',
    'добавление новых блоков и страниц',
    'доработка форм обратной связи',
    'улучшение адаптива и отображения на устройствах',
    'интеграция карт, сервисов и дополнительных функций',
];

const audience = [
    'сайтам, которые уже запущены',
    'проектам с мелкими ошибками',
    'владельцам сайтов, которым нужны точечные улучшения',
    'командам, которым нужна помощь с frontend-разработкой',
];

const steps = [
    'анализ задачи и текущего проекта',
    'оценка объёма работ',
    'внесение изменений',
    'тестирование результата',
    'передача выполненной работы',
];
</script>